import { gql } from '@apollo/client';

export const FETCH_BANK_ACCOUNT_DUE = gql`
  query FetchBankAccountDue($input: ContactPaymentStatFilterInput!) {
    statistic: getContactSummaryStat(contactPaymentStatFilterInput: $input) {
      due
    }
  }
`;
